import React, { useState } from 'react';
import SocialSetupExpertDrawer from '../components/ios26/SocialSetupExpertDrawer';
import { HelpCircle } from 'lucide-react';

/**
 * Demo page for Social Setup Expert Drawer
 * Access at: /demo/expert
 */
export default function ExpertDemo() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedPlatform, setSelectedPlatform] = useState('facebook');

  const platforms = [
    { id: 'facebook', name: 'Facebook', color: '#1877F2' },
    { id: 'instagram', name: 'Instagram', color: '#E1306C' },
    { id: 'x_twitter', name: 'X (Twitter)', color: '#000000' },
    { id: 'pinterest', name: 'Pinterest', color: '#E60023' },
    { id: 'telegram', name: 'Telegram', color: '#0088cc' },
  ];

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 p-8">
      <div className="max-w-2xl mx-auto">
        <h1 className="text-3xl font-bold mb-2 text-gray-900 dark:text-white">
          Social Setup Expert - Demo
        </h1>
        <p className="text-gray-600 dark:text-gray-400 mb-8">
          Cliquez sur une plateforme pour ouvrir l'assistant de configuration.
        </p>

        <div className="grid gap-4">
          {platforms.map((platform) => (
            <button
              key={platform.id}
              onClick={() => {
                setSelectedPlatform(platform.id);
                setDrawerOpen(true);
              }}
              className="flex items-center justify-between p-4 bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 hover:border-blue-500 transition-all"
              data-testid={`demo-platform-${platform.id}`}
            >
              <div className="flex items-center gap-3">
                <div 
                  className="w-10 h-10 rounded-xl"
                  style={{ backgroundColor: platform.color }}
                />
                <span className="font-medium text-gray-900 dark:text-white">
                  {platform.name}
                </span>
              </div>
              <HelpCircle className="w-5 h-5 text-gray-400" />
            </button>
          ))}
        </div>

        <div className="mt-8 p-4 bg-blue-50 dark:bg-blue-900/20 rounded-xl">
          <h3 className="font-medium text-blue-900 dark:text-blue-200 mb-2">
            À propos du Social Setup Expert
          </h3>
          <ul className="text-sm text-blue-800 dark:text-blue-300 space-y-1">
            <li>• <strong>Mode Novice</strong> : Langage simple, étapes guidées</li>
            <li>• <strong>Mode Développeur</strong> : Callback URLs, scopes OAuth, logs</li>
            <li>• Détecte ce qui manque (App ID, Secret, tokens)</li>
            <li>• Guide étape par étape pour configurer</li>
          </ul>
        </div>
      </div>

      <SocialSetupExpertDrawer
        isOpen={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        platform={selectedPlatform}
        projectId={null}
        onAction={(action) => {
          console.log('Action from drawer:', action);
          if (action.type === 'external_link') {
            window.open(action.payload, '_blank');
          }
        }}
      />
    </div>
  );
}
